/* The loader's CSS (inside its shadow root). Positions come from custom properties the loader sets:
   --wfc-f-top/right/bottom/left for the frame, --wfc-l-* for the launcher, --wfc-t-* for the teaser. */
:host {
  all: initial;
}
/* inline: the chat fills the element it's drawn in (give that element a height) */
:host([data-layout="inline"]) {
  display: block;
  height: 100%;
}
.root.inline {
  height: 100%;
}
* {
  box-sizing: border-box;
}
.root {
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
}
button {
  font: inherit;
}

.launcher {
  position: fixed;
  z-index: var(--wfc-z);
  top: var(--wfc-l-top, auto);
  right: var(--wfc-l-right, auto);
  bottom: var(--wfc-l-bottom, auto);
  left: var(--wfc-l-left, auto);
  border: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;
  color: var(--wfc-on-accent);
  background: var(--wfc-accent);
  box-shadow:
    0 10px 30px rgba(8, 12, 30, 0.28),
    0 2px 8px rgba(8, 12, 30, 0.18);
  transition:
    transform 0.18s cubic-bezier(0.2, 0.8, 0.2, 1),
    box-shadow 0.18s,
    opacity 0.18s;
  -webkit-tap-highlight-color: transparent;
}
.launcher:focus-visible {
  outline: 3px solid var(--wfc-accent);
  outline-offset: 3px;
}
.launcher.hidden {
  opacity: 0;
  pointer-events: none;
  transform: scale(0.8);
}

.bubble {
  width: var(--wfc-size);
  height: var(--wfc-size);
  border-radius: 50%;
  display: grid;
  place-items: center;
}
.bubble:hover {
  transform: scale(1.06);
  box-shadow:
    0 14px 36px rgba(8, 12, 30, 0.32),
    0 2px 8px rgba(8, 12, 30, 0.2);
}
.bubble .face {
  width: calc(100% - 6px);
  height: calc(100% - 6px);
  border-radius: 50%;
  object-fit: cover;
  display: block;
}
.bubble .close {
  display: none;
}
.open .bubble .face,
.open .bubble .chat {
  display: none;
}
.open .bubble .close {
  display: block;
}
.bubble .live {
  position: absolute;
  right: 2px;
  bottom: 2px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 0 2px var(--wfc-accent);
}
.open .bubble .live {
  display: none;
}

.tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 12px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.01em;
  white-space: nowrap;
}
.tab.edge-right {
  border-radius: 12px 0 0 12px;
  writing-mode: vertical-rl;
}
.tab.edge-left {
  border-radius: 0 12px 12px 0;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
}
.tab.edge-bottom {
  border-radius: 12px 12px 0 0;
  padding: 10px 18px;
}
.tab.align-center.edge-right,
.tab.align-center.edge-left {
  transform: translateY(-50%);
}
.tab.align-center.edge-left {
  transform: translateY(-50%) rotate(180deg);
}
.tab.align-center.edge-bottom {
  transform: translateX(-50%);
}
.tab .face {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  object-fit: cover;
}
.tab.edge-right .face,
.tab.edge-left .face {
  transform: rotate(90deg);
}
.tab:hover {
  box-shadow: 0 14px 36px rgba(8, 12, 30, 0.32);
}

.badge {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background: #ef4444;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
  box-shadow: 0 0 0 2px #fff;
  writing-mode: horizontal-tb;
}
.badge[hidden] {
  display: none;
}

.teaser {
  position: fixed;
  z-index: var(--wfc-z);
  top: var(--wfc-t-top, auto);
  right: var(--wfc-t-right, auto);
  bottom: var(--wfc-t-bottom, auto);
  left: var(--wfc-t-left, auto);
  max-width: min(300px, calc(100vw - 32px));
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 12px 34px 12px 12px;
  border-radius: 16px;
  background: #fff;
  color: #111827;
  font-size: 14px;
  line-height: 1.4;
  cursor: pointer;
  text-align: left;
  border: 0;
  box-shadow:
    0 12px 40px rgba(8, 12, 30, 0.22),
    0 2px 8px rgba(8, 12, 30, 0.12);
  animation: wfc-pop 0.28s cubic-bezier(0.2, 0.8, 0.2, 1);
}
.teaser img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  flex: none;
}
.teaser .x {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 0;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  display: grid;
  place-items: center;
}
.teaser .x:hover {
  background: #f3f4f6;
}
.teaser[hidden] {
  display: none;
}
@keyframes wfc-pop {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

.frame {
  position: fixed;
  z-index: var(--wfc-z);
  top: var(--wfc-f-top, auto);
  right: var(--wfc-f-right, auto);
  bottom: var(--wfc-f-bottom, auto);
  left: var(--wfc-f-left, auto);
  width: var(--wfc-w);
  height: var(--wfc-h);
  max-width: calc(100vw - 16px);
  max-height: var(--wfc-maxh, calc(100vh - 16px));
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition:
    opacity 0.18s ease,
    transform 0.2s cubic-bezier(0.2, 0.8, 0.2, 1),
    visibility 0s linear 0.2s;
}
.frame iframe {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
  background: transparent;
  color-scheme: normal;
}
.open .frame {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: none;
  transition-delay: 0s;
}

.layout-panel .frame {
  border-radius: var(--wfc-radius);
  overflow: hidden;
  transform: translateY(14px) scale(0.97);
  transform-origin: var(--wfc-origin);
  box-shadow:
    0 24px 64px rgba(8, 12, 30, 0.3),
    0 4px 16px rgba(8, 12, 30, 0.18);
}
.layout-drawer .frame {
  top: 0;
  bottom: 0;
  height: 100%;
  max-height: none;
  box-shadow: 0 0 64px rgba(8, 12, 30, 0.32);
}
.layout-drawer.side-right .frame {
  right: 0;
  left: auto;
  transform: translateX(105%);
}
.layout-drawer.side-left .frame {
  left: 0;
  right: auto;
  transform: translateX(-105%);
}
.layout-floating .frame {
  transform: translateY(10px);
  background: transparent;
}
.layout-floating.passthrough .frame {
  pointer-events: none;
}

/* open beats every layout's closed transform */
.root.open:is(.layout-panel, .layout-drawer, .layout-floating) .frame {
  transform: none;
}

.scrim {
  position: fixed;
  inset: 0;
  z-index: var(--wfc-z);
  background: rgba(8, 12, 30, 0.38);
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 0.2s,
    visibility 0s 0.2s;
}
.open.modal .scrim {
  opacity: 1;
  visibility: visible;
  transition-delay: 0s;
}

.inline .frame {
  position: relative;
  inset: auto;
  width: 100%;
  height: 100%;
  min-height: 420px;
  max-width: none;
  max-height: none;
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: none;
  border-radius: var(--wfc-radius);
  overflow: hidden;
}

.fullscreen.open .frame {
  top: var(--wfc-vv-top, 0px);
  left: 0;
  right: 0;
  bottom: auto;
  width: 100%;
  height: var(--wfc-vv-height, 100%);
  max-width: none;
  max-height: none;
  border-radius: 0;
  transform: none;
}
.fullscreen.open .launcher,
.fullscreen.open .teaser {
  display: none;
}

.hide-mobile .launcher {
  display: none;
}

@media (prefers-reduced-motion: reduce) {
  .frame,
  .launcher,
  .scrim {
    transition:
      opacity 0.1s linear,
      visibility 0s !important;
    transform: none !important;
  }
  .tab.align-center.edge-right {
    transform: translateY(-50%) !important;
  }
  .teaser {
    animation: none;
  }
}

/* icon "face": the picture breathes a little, so the launcher feels alive ("avatar" stays still) */
.launcher img.face.alive {
  animation: wfc-breathe 4.2s ease-in-out infinite;
}
@keyframes wfc-breathe {
  0%,
  100% {
    transform: scale(1);
    filter: brightness(1);
  }
  50% {
    transform: scale(1.045);
    filter: brightness(1.07);
  }
}
@media (prefers-reduced-motion: reduce) {
  .launcher img.face.alive {
    animation: none;
  }
}
